/* eslint-disable linebreak-style */
/* eslint-disable function-paren-newline */
/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable no-confusing-arrow */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable quotes */
/* eslint-disable indent */
/* eslint-disable react/jsx-curly-newline */

import { AppAction } from "../../../../redux/actionType";
import * as types from "./contactAndForms.actionTypes";

const initialState = {
  isSubmitting: false,
};

// eslint-disable-next-line
export default (state = initialState, action: AppAction) => {
  switch (action?.type) {
    case types.CONTACT_START:
      return {
        ...state,
        isSubmitting: true,
      };
    case types.CONTACT_SUCCESS:
    case types.CONTACT_FAILURE:
      return {
        ...state,
        isSubmitting: false,
      };
    default:
      return { ...state };
  }
};
